<kendo-dialog [width]="'90%'" [maxWidth]="'400px'" (close)="closed.emit()">
  <kendo-dialog-titlebar>
    <p class="subtitle-1 text-black">
      {{ 'outlook.email.form.title' | translate }}
    </p>
  </kendo-dialog-titlebar>

  @if (loading) {
    <maximizer-loader type="legacy"></maximizer-loader>
  }

  <div class="h-full narrow flex flex-col justify-between gap-4">
    <form [formGroup]="form.group" class="flex flex-col gap-2 text-body">
      <kendo-formfield>
        <kendo-label
          [for]="name"
          [text]="'outlook.email.form.emailSubject' | translate"
        >
          <kendo-textbox
            #name
            formControlName="name"
            [placeholder]="'outlook.email.form.subjectPlaceholder' | translate"
            required
          ></kendo-textbox>
        </kendo-label>

        <kendo-formerror>
          @if (form.controls.name.hasError('required')) {
            {{ 'outlook.forms.requiredField' | translate }}
          }
        </kendo-formerror>
      </kendo-formfield>
      <kendo-formfield>
        <kendo-label [text]="'outlook.email.form.fullAccess' | translate">
          <kendo-dropdownlist
            formControlName="fullAccess"
            [data]="fullAccess"
            valueField="id"
            textField="name"
            [valuePrimitive]="true"
          ></kendo-dropdownlist>
        </kendo-label>
      </kendo-formfield>
      <kendo-formfield>
        <kendo-label [text]="'outlook.email.form.readAccess' | translate">
          <kendo-dropdownlist
            formControlName="readAccess"
            [data]="readAccess"
            valueField="id"
            textField="name"
            [valuePrimitive]="true"
          ></kendo-dropdownlist>
        </kendo-label>
      </kendo-formfield>
      <kendo-formfield>
        <kendo-label [text]="'outlook.email.form.category' | translate">
          <kendo-dropdownlist
            formControlName="category"
            [data]="category"
            valueField="id"
            textField="name"
            [valuePrimitive]="true"
          ></kendo-dropdownlist>
        </kendo-label>
      </kendo-formfield>
      <kendo-formfield>
        <kendo-label [text]="'outlook.email.form.result' | translate">
          <kendo-dropdownlist
            formControlName="result"
            [data]="result"
            valueField="id"
            textField="name"
            [valuePrimitive]="true"
          ></kendo-dropdownlist>
        </kendo-label>
      </kendo-formfield>
      <kendo-formfield>
        <div class="flex gap-2 mt-2 items-center">
          <kendo-checkbox formControlName="attachment"></kendo-checkbox>
          <kendo-label
            [text]="'outlook.email.form.attachment' | translate"
          ></kendo-label>
          <span
            kendoTooltip
            class="fa-icons icon-12 icon-solid icon-circle-question text-neutral-90"
            title="{{ 'outlook.email.form.attachmentHelp' | translate }}"
            [tooltipWidth]="250"
            [tooltipTemplate]="tooltip"
            [callout]="false"
          ></span>
        </div>
        <ng-template #tooltip>
          <p class="text-body">
            {{ 'outlook.email.form.attachmentHelp' | translate }}
          </p>
        </ng-template>
      </kendo-formfield>
    </form>

    <div class="flex justify-end gap-2">
      <button
        kendoButton
        themeColor="secondary"
        (click)="this.closed.emit()"
      >
        {{ 'outlook.buttons.cancel' | translate }}
      </button>
      <button
        kendoButton
        themeColor="primary"
        [disabled]="!form.group.valid || loading"
        (click)="save()"
        iconClass="maximizer-icons icon-save-email icon-18"
      >
        {{ 'outlook.buttons.saveEmail' | translate }}
      </button>
    </div>
  </div>
</kendo-dialog>

<maximizer-outlook-notification
  #notification
  [closable]="true"
></maximizer-outlook-notification>
